export const PARAMS = {
	ORGANIZATION_ID: 'organizationId',
	ORGANIZATION_SLUG: 'organizationSlug',
	DOMAIN_ID: 'domainId',
	STORY_ID: 'storyId',
	CARD_ID: 'cardId',
	INPUT_ID: 'inputId',
	TEAM_ID: 'teamId',
	MEMBER_ID: 'memberId',
	TEMPLATE_ID: 'templateId',
	PROVIDER: 'provider',
	REDIRECT: 'redirect', // '0' | undefined
	WEBHOOK_ID: 'webhookId',
	WEBHOOK_LOG_ID: 'webhookLogId',
	GENERATOR_ID: 'generatorId',
	VIDEO_ID: 'videoId',
	VIDEO_UPLOAD_COMPLETE_ID: 'videoUploadCompleteId',
	COLLECTION_ID: 'collectionId',
	COLLECTION_ITEM_ID: 'cmsItemId',
	UPLOADED_FILE_KEY: 'fileKey',
} as const;

export const SEARCH_PARAMS = {
	EDITOR_PREVIEW: 'editor',
	EMBED_DEV: 'embedDev',
};
